import http from "./http";

// 获取用户信息
export function userInfo() {
  return new Promise((resolve, reject) => {
    http.get("/account/profile").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 获取作品
export function getCourse(params) {
  return new Promise((resolve, reject) => {
    http.post("/course/", params).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 获取教师账号
export function getAllUser() {
  return new Promise((resolve, reject) => {
    http.get("/account").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 查看当前校区
export function get_all_campus() {
  return new Promise((resolve, reject) => {
    http.get("/rbac/subject/pred").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 添加教师账号
export function postTeacher(data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/account", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 添加班级
export function add_class_api(name, data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/school/class?name=" + name, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 获取班级
export function get_class_api(name) {
  return new Promise((resolve, reject) => {
    http.get("/school/class?name=" + name).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//修改班级
export function edit_class_api(id, data) {
  return new Promise((resolve, reject) => {
    http.put("/school/class?id=" + id , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
